import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { fetchClientSentryConfig, initAppSentry } from './utils/sentry';
import './styles/globals.css';

// Error reporting (no-op until the backend hands us a DSN; see /api/client-config)
void fetchClientSentryConfig().then((cfg) => { if (cfg) initAppSentry(cfg); });

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"> in your HTML.',
  );
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 32, fontFamily: 'system-ui, sans-serif' }}>
          <h1 style={{ fontSize: 18 }}>Κάτι πήγε στραβά / Something went wrong</h1>
          <p>Το σφάλμα καταγράφηκε. Ανανεώστε τη σελίδα. / The error was reported. Please reload.</p>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
